/**
 * SELECT Options 对应的 item 的字段
 * @type {{CODE: 'value值', LABEL: '显示名称'}}
 */
export const SELECT_OPTION_CONFIG = {
  LABEL: "label",
  CODE: "code",
  CHILDREN: "children",
  VISIBLE: "visible",
};
// 信息发布类菜单 顶层导航栏对应内容
export const TOP_NAV_MENU_CODE = {
  // 通知公告
  tzgg: { img: require("@/assets/images/side-nav/tzgg.jpg") },
  // 机构动态
  jgdt: { img: require("@/assets/images/side-nav/jgdt.jpg") },
  // 案例中心
  alzx: { img: require("@/assets/images/side-nav/alzx.jpg") },
  // 政策法规
  zcfg: { img: require("@/assets/images/side-nav/zcfg.jpg") },
  // 服务指南
  fwzn: { img: require("@/assets/images/side-nav/fwzn.jpg") },
  // 联系我们
  lxwm: { img: require("@/assets/images/side-nav/lxwm.jpg") },
  // 抵押
  dy: { img: require("@/assets/images/side-nav/dy.jpg") },
  // 中止/终结公告
  zzgg: { img: require("@/assets/images/side-nav/zzgg.jpg") },
  // 成交公告
  cjgg: { img: require("@/assets/images/side-nav/cjgg.jpg") },
};
// 广告位 对应的 code
export const AD_CODE = {
  // banner 图
  BANNER: "banner",
  // 首页 一号广告位
  AD_A: "ad_a",
  // 首页 二号广告位
  AD_B: "ad_b",
  // 首页 平台动态/通知公告 模块边上的 图片新闻
  AD_NEWS: "ad_news",
};

// 头部导航的所有code 配置时 记得添加
export const NAV_MENU_CODE = {
  // 首页
  HOME: "home",
  // 项目信息/招标公告
  PURCHASE: "xmxx",
  // 平台信息
  PLATFORM_INFO: "ptxx",
  // 政策法规
  LAWS_POLICY: "zcfg",
  // 服务指南
  SERVICE_GUIDE: "fwzn",
  // 平台动态
  PLATFORM_UPDATES: "ptdt",
  // 机构动态
  PLATFORM_UPDATES: "jgdt",
  // 通知公告
  NOTICES: "tzgg",
  // 常见问题
  FAQ: "cjwt",
  // 关于我们
  ABOUT_US: "gywm",
  // 抵押
  dy: "dy",
};

/**
 * 适用于头部搜索框内,切换查询条件的下拉框
 * @type {{PROJECT_CODE: {CODE: string, LABEL: string}, PROJECT_NAME: {CODE: string, LABEL: string}}}
 */
export const SEARCH_INPUT_OPTIONS_TYPES = {
  BIDDING_NOTICE: {
    [SELECT_OPTION_CONFIG.LABEL]: "产权交易",
    [SELECT_OPTION_CONFIG.CODE]: NAV_MENU_CODE.PURCHASE,
  },
  DY: {
    [SELECT_OPTION_CONFIG.LABEL]: "抵押项目",
    [SELECT_OPTION_CONFIG.CODE]: NAV_MENU_CODE.dy,
  },
  NOTICES: {
    [SELECT_OPTION_CONFIG.LABEL]: "通知公告",
    [SELECT_OPTION_CONFIG.CODE]: NAV_MENU_CODE.NOTICES,
  },
  PLATFORM_UPDATES: {
    [SELECT_OPTION_CONFIG.LABEL]: "机构动态",
    [SELECT_OPTION_CONFIG.CODE]: NAV_MENU_CODE.PLATFORM_UPDATES,
  },
};

// 公告类型 枚举值
export const NOTICE_TYPE_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.LABEL]: "全部",
    [SELECT_OPTION_CONFIG.CODE]: "",
  },
  GKZB: {
    [SELECT_OPTION_CONFIG.LABEL]: "招标公告",
    [SELECT_OPTION_CONFIG.CODE]: "gkzb",
  },
  JZXTP: {
    [SELECT_OPTION_CONFIG.LABEL]: "竞争性谈判",
    [SELECT_OPTION_CONFIG.CODE]: "jzxtp",
  },
  JZXCS: {
    [SELECT_OPTION_CONFIG.LABEL]: "竞争性磋商",
    [SELECT_OPTION_CONFIG.CODE]: "jzxcs",
  },
  XJCG: {
    [SELECT_OPTION_CONFIG.LABEL]: "询价采购",
    [SELECT_OPTION_CONFIG.CODE]: "xjcg",
  },
  DYLY: {
    [SELECT_OPTION_CONFIG.LABEL]: "单一来源采购",
    [SELECT_OPTION_CONFIG.CODE]: "dyly",
  },
};

// 项目类型枚举值
export const PROJECT_TYPE_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.LABEL]: "全部",
    [SELECT_OPTION_CONFIG.CODE]: "",
    value: "",
    EN: "ALL",
  },
  ZR: {
    [SELECT_OPTION_CONFIG.LABEL]: "转让",
    [SELECT_OPTION_CONFIG.CODE]: "ZR",
    value: "1",
    EN: "",
  },
  CZ: {
    [SELECT_OPTION_CONFIG.LABEL]: "出租",
    [SELECT_OPTION_CONFIG.CODE]: "CZ",
    value: "2",
    EN: "",
  }
};

// 项目状态枚举值
export const PROJECT_STATUS_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.LABEL]: "全部",
    [SELECT_OPTION_CONFIG.CODE]: "",
    [SELECT_OPTION_CONFIG.VISIBLE]: true,
  },
  WKS: {
    [SELECT_OPTION_CONFIG.LABEL]: "未开始",
    [SELECT_OPTION_CONFIG.CODE]: "8",
    [SELECT_OPTION_CONFIG.VISIBLE]: true,
  },
  ZZBM: {
    [SELECT_OPTION_CONFIG.LABEL]: "正在报名",
    [SELECT_OPTION_CONFIG.CODE]: "10",
    [SELECT_OPTION_CONFIG.VISIBLE]: true,
  },
  BMYJZ: {
    [SELECT_OPTION_CONFIG.LABEL]: "报名已截止",
    [SELECT_OPTION_CONFIG.CODE]: "7",
    [SELECT_OPTION_CONFIG.VISIBLE]: true,
  },
  JJZ: {
    [SELECT_OPTION_CONFIG.LABEL]: "竞价中",
    [SELECT_OPTION_CONFIG.CODE]: "9",
    [SELECT_OPTION_CONFIG.VISIBLE]: true,
  },
  JJJZ: {
    [SELECT_OPTION_CONFIG.LABEL]: "竞价截止",
    [SELECT_OPTION_CONFIG.CODE]: "6",
    [SELECT_OPTION_CONFIG.VISIBLE]: true,
  },
  YCJ: {
    [SELECT_OPTION_CONFIG.LABEL]: "已成交",
    [SELECT_OPTION_CONFIG.CODE]: "5",
    [SELECT_OPTION_CONFIG.VISIBLE]: true,
  },
  YZT: {
    [SELECT_OPTION_CONFIG.LABEL]: "已暂停",
    [SELECT_OPTION_CONFIG.CODE]: "1",
    [SELECT_OPTION_CONFIG.VISIBLE]: false,
  },
  CXGP: {
    [SELECT_OPTION_CONFIG.LABEL]: "重新挂牌",
    [SELECT_OPTION_CONFIG.CODE]: "2",
    [SELECT_OPTION_CONFIG.VISIBLE]: false,
  },
  YZZ: {
    [SELECT_OPTION_CONFIG.LABEL]: "已中止",
    [SELECT_OPTION_CONFIG.CODE]: "3",
    [SELECT_OPTION_CONFIG.VISIBLE]: false,
  },
  YZJ: {
    [SELECT_OPTION_CONFIG.LABEL]: "已终结",
    [SELECT_OPTION_CONFIG.CODE]: "4",
    [SELECT_OPTION_CONFIG.VISIBLE]: false,
  },
  BMZ_JJZ: {
    [SELECT_OPTION_CONFIG.LABEL]: "报名中，竞价中",
    [SELECT_OPTION_CONFIG.CODE]: "11",
    [SELECT_OPTION_CONFIG.VISIBLE]: false,
  },
};

// 项目信息
export const PROJECT_INFO_TEXT = {
  1: "竞价暂停",
  2: "重新挂牌",
  3: "中止",
  4: "终结",
  5: "已成交",
  6: "竞价截止",
  7: "报名已截止",
  8: "未开始",
  9: "竞价中",
  10: "正在报名",
  11: "报名中，竞价中",
};

// 状态对应按钮文字
export const PROJECT_STATUS_BUTTON_TEXT = {
  0: "未开始",
  1: "报名",
  2: "报名截止",
  3: "我要参加",
  4: "详见公告",
  5: "已中标",
  6: "已废标",
  7: "重新招标",
  8: "已中标",
  9: "详见公告",
  10: "详见公示",
  default: "详见公告",
};

// 信息类型
export const INFO_TYPE_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.LABEL]: "全部",
    [SELECT_OPTION_CONFIG.CODE]: "",
  },
  ZBGG: {
    [SELECT_OPTION_CONFIG.LABEL]: "采购公告",
    [SELECT_OPTION_CONFIG.CODE]: "1",
  },
  BGGG: {
    [SELECT_OPTION_CONFIG.LABEL]: "澄清/变更公告",
    [SELECT_OPTION_CONFIG.CODE]: "2",
  },
  ZBHXRGS: {
    [SELECT_OPTION_CONFIG.LABEL]: "候选人公示",
    [SELECT_OPTION_CONFIG.CODE]: "3",
  },
  ZBJG: {
    [SELECT_OPTION_CONFIG.LABEL]: "结果公告",
    [SELECT_OPTION_CONFIG.CODE]: "4",
  },
};

// 组织形式
export const ORGANIZATION_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.CODE]: "",
    [SELECT_OPTION_CONFIG.LABEL]: "全部",
  },
  WTCG: {
    [SELECT_OPTION_CONFIG.CODE]: "1",
    [SELECT_OPTION_CONFIG.LABEL]: "机构",
  },
  QYZZ: {
    [SELECT_OPTION_CONFIG.CODE]: "2",
    [SELECT_OPTION_CONFIG.LABEL]: "自主",
  },
};

// 平台信息
export const PLATFORM_INFO_TYPE_OPTIONS = {
  PTDT: {
    [SELECT_OPTION_CONFIG.LABEL]: "公告",
    [SELECT_OPTION_CONFIG.CODE]: "ptdt",
  },
  BGGG: {},
};

export const MAP_ACTION = {
  SET: "set",
  DEL: "delete",
  HAS: "has",
  CLEAR: "clear",
};

export const PERMISSION_ROLE = {
  MENU: "MENU",
  SITE: "SITE",
};

// 友情链接 的枚举值
export const LINK_TYPE = {
  // 发布媒体
  FBMT: "fbmt",
  // 采购代理机构
  CGDLJG: "cgdljg",
  // 区直国企
  QZGQ: "qzgq",
  // 国资监管
  GZJG: "gzjg",
  // 合作机构
  HZJG: "hzjg",
  // 友情链接
  FRIENDLY_LINK: "default",
};

/**
 * 注册页面使用的常量
 * @type {{REGISTER_TYPE_CGR: string, SYSTEM_XXFB: string, SYSTEM_QYZC: string, REGISTER_TYPE_GYS: string, SSJT_OTHER_CODE: number}}
 */
export const REGISTER_PAGE_CONSTANT = {
  // 所属集团 选择 其他 对应的 code
  SSJT_OTHER_CODE: -1,
  // 注册身份: 供应商
  REGISTER_TYPE_GYS: "17",
  // 注册身份: 采购人
  REGISTER_TYPE_CGR: "12",
  // 系统服务: 信息发布
  SYSTEM_XXFB: "1",
  // 系统服务: 企业自采
  SYSTEM_QYZC: "2",
};
/**
 * 获取 会员协议 对应的 页面类型
 * @type {{MEMBER_REGISTER: string, ENTERPRISE_ENTER: string}}
 */
export const PROTOCOL_PAGE_TYPE = {
  // 会员注册
  MEMBER_REGISTER: "1",
  // 入驻申请
  ENTERPRISE_ENTER: "2",
};

/**
 * 注册页面, 获取用户协议是, 对应的用户身份
 * @type {{GYS: string, CGR: string}}
 */
export const PROTOCOL_TYPE = {
  // 采购人
  [REGISTER_PAGE_CONSTANT.REGISTER_TYPE_CGR]: "cgr",
  // 供应商
  [REGISTER_PAGE_CONSTANT.REGISTER_TYPE_GYS]: "gys",
};

/**
 * 文件上传通用 url
 * @type {string}
 */
export const UPLOAD_FILE_URI =
  process.env.VUE_APP_BASE_API +
  process.env.VUE_APP_APP_API +
  "/infra/file/upload";

/**
 * 模版文件 code
 * @type {{SQS_FGS: string, SQS: string, SFZ: string}}
 * @desc {{SQS_FGS: 授权书模板(分公司注册版本), SQS: 授权书模板, SFZ: 身份证明}}
 */
export const TEMPLATE_CODE = {
  // 身份证明
  SFZ: "sfz",
  // 授权书模板
  SQS: "sqs",
  // 授权书模板(分公司注册版本)
  SQS_FGS: "sqs_fgs",
};
/**
 * 模版文件 pageType
 * @type {{ORG: string, MEMBER: string}}
 * @desc {{ORG: 入驻申请, MEMBER: 会员注册 }}
 */
export const TEMPLATE_PAGE_TYPE = {
  MEMBER: "member",
  ORG: "org",
};
// 单位类型
export const UNIT_TYPE_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.CODE]: "",
    [SELECT_OPTION_CONFIG.LABEL]: "全部",
  },
  CITY: {
    [SELECT_OPTION_CONFIG.CODE]: "1",
    [SELECT_OPTION_CONFIG.LABEL]: "市属企业",
  },
  COUNTY: {
    [SELECT_OPTION_CONFIG.CODE]: "2",
    [SELECT_OPTION_CONFIG.LABEL]: "区县（市）企业",
  },
};

export function getConstantDic(dicObj) {
  const isVisible = (item) =>
    !item.hasOwnProperty(SELECT_OPTION_CONFIG.VISIBLE) ||
    item[SELECT_OPTION_CONFIG.VISIBLE];
  return Object.values(dicObj).filter((item) => isVisible(item));
}
